import BaseApi from "./BaseApi";

const baseUrl = 'api/file/';

class FileService {

    static getBlobSas(request:any): Promise<any> {
        return BaseApi.post(`${baseUrl}sasBlob`,request);
    }

    static getUrlBlobByFile(request:any): Promise<any> {
        return BaseApi.post(`${baseUrl}SaveFileinBlob`,request);
    }
}

export default FileService;